import React, {useContext, useEffect, useState} from 'react';
import {Col, Row, Button, Form, Spinner} from "react-bootstrap";
import styles from "./modal-content-order-summary.module.scss";
import OrderAcceptModalContent from "../modal-content-order-accept/modal-content-order-accept";
import OrderRejectModalContent from "../modal-content-order-reject/modal-content-order-reject";
import Loading from "../../../../../components/loading/loading";
import numToWords from '../../../../../helpr/numToWords';
import {formatDate, formatDateTime, toCurrency} from "../../../../../helpr/helper";
import {
  ORDER_ACCEPTED,
  ORDER_ALLOCATION_EXCEEDED_ERROR,
  ORDER_CONFIRM_ERROR,
  ORDER_SCALE_DOWN_ABOVE,
  ORDER_SCALE_DOWN_INVALID,
  ORDER_SCALE_DOWN_LESS_MINIMUM,
  ORDER_SCALE_DOWN_WRONG_INCREMENT
} from "../../../../../helpr/constants";
import editIcon from "../../../../../assets/edit.svg";
import checkIcon from "../../../../../assets/orders-table-accept.svg";
import rejectIcon from "../../../../../assets/orders-table-reject.svg";
import {
  REDUCER_ACTION_UPDATE_AMOUNT,
  SecurityContext,
  SecurityDispatchContext
} from "../../../../../context/security-context";
import SecurityService from "../../../../../services/security-service";
import OrderForm from '../../../../invest/components/order-form/order-form';
import {
  bankListMap,
  securityRegistrationMap,
  deliveryModesMap,
  investorCategoryMap,
  modeOfCollectionOfInterestMap,
  idTypesMap,
  modeOfPaymentsMap
} from '../../../../../helpr/orderFormData';


// Modal Screen Types
const SUMMARY = 0; //Order Summary Screen
const ACCEPT = 1; //Accept Confirmation Screen
const REJECT = 2; //Reject Confirmation Screen

const OrderSummaryModalContent = ({order, onClose, modalConfig}) => {
  // Retrieve orders and security details state from context
  const { ordersState, securityState } = useContext(SecurityContext);
  const { ordersDispatch } = useContext(SecurityDispatchContext);
  // Define modal states
  const [ page, setPage ] = useState(SUMMARY); //For screen types
  const [ loading, setLoading] = useState(false); //For order details loading
  const [ orderDetailsState, setOrderDetailsState] = useState({}); //For order detail state
  const getUpdatedOrder = () => ordersState.filtered.filter(o => o.orderId === order.orderId)[0].scaledAmount;
  const [ scaleDownState, setScaleDownState ] = useState({
    amount: getUpdatedOrder(),
    field: false,
    loading: false,
    errorMessage: ''
  }); //For purchase amount scale down state
  // Define service
  const securityService = new SecurityService();

  // Retrieve order details on modal load
  useEffect(()=>{
    const getOrderDetails = async () => {
      try {
        setLoading(true);
        const orderDetails = await securityService.getOrder(securityState.securityId, order.orderId);
        console.log(orderDetails);
        setOrderDetailsState(orderDetails);
      } catch(error) {
      } finally {}
      setLoading(false)
    };
    getOrderDetails()
    // eslint-disable-next-line
  }, [])

  useEffect(()=>{
    console.log(orderDetailsState);
  },[orderDetailsState]);

  //Hide/show scale down text field
  const toggleScaleDownField = () => {
    setScaleDownState({
      ...scaleDownState,
      field: !scaleDownState.field
    });
  }
  //Set input amount on state and corresponding error messages to show
  const handleAmountChange = (e) => {
    const amt = e.target.value;
    let msg = '';
    if (!Number(amt)) {
      msg = ORDER_SCALE_DOWN_INVALID;
    }
    if (amt > Number(order.purchaseAmount)) {
      msg = ORDER_SCALE_DOWN_ABOVE;
    }
    //Check denomination
    const increment = securityState.denomination.value.primary.increments;
    const minimum = securityState.denomination.value.primary.minimum;
    console.log(increment, minimum)
    if (amt < minimum) {
      msg = ORDER_SCALE_DOWN_LESS_MINIMUM
    }
    if ((amt % increment) != 0) {
      msg = ORDER_SCALE_DOWN_WRONG_INCREMENT
    }

    setScaleDownState({
      ...scaleDownState,
      amount: amt,
      errorMessage: msg
    })
  }
  const isAllocationExceeded = (amt) => {
    return (ordersState.default.filter(o => o.orderStatus === '1' && o.orderId !== order.orderId)
      .reduce((total, o) => total + o.scaledAmount, 0) + amt) > securityState.allocation;
  }
  const isDenominationValid = (amt) => {
    //Check denomination
    const increment = securityState.denomination.value.primary.increments;
    const minimum = securityState.denomination.value.primary.minimum;
    if (amt < minimum) {
      return false;
    }
    if ((amt % increment) != 0) {
      return false;
    }
    return true;
  }
  //Scale down purchase amount API call
  const scaleDown = async () => {
    if(!Number(scaleDownState.amount) || (scaleDownState.amount > Number(order.purchaseAmount))) {
      return
    }
    if(!isDenominationValid(Number(scaleDownState.amount))){
      return
    }
    // if(order.orderStatus === ORDER_ACCEPTED && isAllocationExceeded(Number(scaleDownState.amount))){
    //   setScaleDownState({
    //     ...scaleDownState,
    //     errorMessage: ORDER_ALLOCATION_EXCEEDED_ERROR
    //   })
    //   return
    // }
    setScaleDownState({
      ...scaleDownState,
      loading: true
    })
    try {
      await securityService.scaleDownOrder(securityState.securityId, order.orderId, scaleDownState.amount);
      ordersDispatch({
        type: REDUCER_ACTION_UPDATE_AMOUNT,
        previous: ordersState,
        data: {
          id: order.orderId,
          value: Number(scaleDownState.amount)
        }
      });
    } catch(error) {
      setScaleDownState({
        ...scaleDownState,
        errorMessage: ORDER_CONFIRM_ERROR
      });
    } finally {
      setScaleDownState({
        ...scaleDownState,
        field: false
      });
    }
  }

  //Dynamic Modal Screen
  const renderModalScreen = () => {
    switch(page){
      case SUMMARY:
        return renderSummaryScreen()
      case ACCEPT:
        return <OrderAcceptModalContent order={order} onCancel={() => setPage(SUMMARY)} onClose={onClose} modalConfig={modalConfig}/>
      case REJECT:
        return <OrderRejectModalContent order={order} onCancel={() => setPage(SUMMARY)} onClose={onClose} modalConfig={modalConfig}/>
      default:
        return ''
    }
  }

  //SUMMARY Screen and Dynamic Components
  const renderSummaryScreen = () => {
    return loading
      ? <Loading />
      : <div className={styles['order-summary']}>
        <Row>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="atp">Reference Number</label></div></Col>
          <Col xs={6} lg={6}><p>{order.refNumber}</p></Col>
          {order.purchaseAmount !== getUpdatedOrder()
            ? (
              <>
                <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="atp">Original Amount</label></div></Col>
                <Col xs={6} lg={6}><p>{toCurrency(order.purchaseAmount)}</p></Col>
              </>
            ): ''
          }
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="atp">Amount</label></div></Col>
          <Col xs={6} lg={6}>
            {scaleDownState.field
              ? (
                <span className={styles['purchase-amount-input']}>
                    <Form.Control className={scaleDownState.errorMessage ? styles['purchase-amount-input-error']: ''}
                                  size="sm" type="number" placeholder="Purchase Amount"
                                  value={scaleDownState.amount} onChange={handleAmountChange} />
                  {!scaleDownState.loading
                    ? (
                      <><span onClick={() => scaleDown()} className={styles['confirm-scale-down']}>
                          <img alt="Confirm" src={checkIcon} />
                        </span>
                        <span onClick={() => toggleScaleDownField()} className={styles['cancel-scale-down']}>
                          <img alt="Cancel" src={rejectIcon}/>
                        </span></>
                    ) : (
                      <div className={styles['loading-scale-down']}>
                        <Spinner size="sm" animation="border" />
                      </div>
                    )}
                  </span>
              ) : (
                <span className={styles['purchase-amount']}>
                    <p>{order.orderId !== undefined ? toCurrency(getUpdatedOrder()) : ''}</p>
                  {order.orderStatus !== '2' && securityState.securityStatus === '0'
                    ? <img onClick={()=>toggleScaleDownField()} alt="Edit" src={editIcon} /> : ''}
                  </span>
              )}
          </Col>

          {scaleDownState.errorMessage
            ? (
              <>
                <Col xs={6} lg={6}></Col>
                <Col xs={6} lg={6}><div className={styles['error']}><label>{scaleDownState.errorMessage}</label></div></Col>
              </>
            ) : ''
          }

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>

          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="primaryContactName">Investor/s</label></div></Col>
          <Col xs={6} lg={6}>
            <p>
              {order.primaryApplicant}{' '}
              {orderDetailsState.applicantList && orderDetailsState.applicantList.applicants.length > 0
                ? orderDetailsState.applicantList.assoc : ''}
            </p>
          </Col>
          {
            orderDetailsState.applicantList && orderDetailsState.applicantList.applicants.map((applicant, i) => i !== 0 && (
              <>
                <Col xs={6} lg={6}></Col>
                <Col xs={6} lg={6}><p>{`${applicant.first_name} ${applicant.last_name}`}</p></Col>
              </>
            ))
          }
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="category">Primary Contact</label></div></Col>
          <Col xs={6} lg={6}><p>
            {
              ( (orderDetailsState.primaryContactPerson && orderDetailsState.primaryContactPerson.lastName)
               && orderDetailsState.primaryContactPerson.lastName + ', ' + orderDetailsState.primaryContactPerson.firstName
               + ' ' + orderDetailsState.primaryContactPerson.middleName + '(' + orderDetailsState.primaryContactPerson.relation + ')')
            }
          </p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="category">Investor Category</label></div></Col>
          <Col xs={6} lg={6}><p>{investorCategoryMap(orderDetailsState.investorCategory)}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="nationality">Nationality:</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.nationality}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="place">Place:</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.place}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="address">Permanent Address</label></div></Col>
          <Col xs={6} lg={6}><p>
            { orderDetailsState.address && orderDetailsState.address.streetAddress + ', ' + orderDetailsState.address.districtOrTown + ' '
            + orderDetailsState.address.city + ' '  + orderDetailsState.address.stateProvinceRegion }
          </p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="address">Present Address</label></div></Col>
          <Col xs={6} lg={6}><p>
            { orderDetailsState.presentAddress && orderDetailsState.presentAddress.streetAddress + ', ' + orderDetailsState.presentAddress.districtOrTown + ' '
             + orderDetailsState.presentAddress.city + ' '  + orderDetailsState.presentAddress.stateProvinceRegion }
          </p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="address">Email Address</label></div></Col>
          <Col xs={6} lg={6}><p>
            {(orderDetailsState.investorCategory === 'INDV' && orderDetailsState.applicantList['applicants'].length > 1)
              ? orderDetailsState.applicantList.applicants.map(a => a.email).join(', ')
              : orderDetailsState.emailAddress}
          </p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="dateOfBirth">
            { orderDetailsState.investorCategory === 'INDV'? 'Date of Birth' : 'Date of Incorporation' }
          </label></div></Col>
          <Col xs={6} lg={6}><p>
            {(orderDetailsState.investorCategory === 'INDV' && orderDetailsState.applicantList['applicants'].length > 1)
              ? orderDetailsState.applicantList.applicants.map(a => formatDate(a.date_of_birth)).join(', ')
              : formatDate(orderDetailsState.dateOfBirthOrIncorporation)}
          </p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="placeOfBirth">
            { orderDetailsState.investorCategory === 'INDV'? 'Place of Birth' : 'Place of Incorporation' }
          </label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.placeOfBirthOrIncorporation}</p></Col>

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>

          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">ID Type</label></div></Col>
          <Col xs={6} lg={6}><p>{idTypesMap(orderDetailsState.idType)}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">ID Number</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.idNumber}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">Tax Status</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.taxStatus}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="order-date">Reservation Date</label></div></Col>
          <Col xs={6} lg={6}><p>{formatDateTime(order.createdDate)}</p></Col>

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Telephone Numbers</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.contactNumbers && orderDetailsState.contactNumbers.telephoneNumbers.join(', ')}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Fax Numbers</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.contactNumbers && orderDetailsState.contactNumbers.faxNumbers.join(', ')}</p></Col>

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">
            { orderDetailsState.investorCategory === 'INDV'? 'Nature of Work/Business': 'Principal Business of the Corporation' }
          </label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.businessDetails && orderDetailsState.businessDetails.nature}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Parent Company</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.businessDetails && orderDetailsState.businessDetails.parentCompany}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Name of Business</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.businessDetails && orderDetailsState.businessDetails.name}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Sources of Income</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.businessDetails && orderDetailsState.businessDetails.sourcesOfIncome.join(', ')}</p></Col>

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>

          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Mode of Payment</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.modeOfPayment && modeOfPaymentsMap(orderDetailsState.modeOfPayment.option)}</p></Col>
          { orderDetailsState.modeOfPayment && orderDetailsState.modeOfPayment.option === 'BANK_CHECK'
            ? <>
              <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Drawee Bank</label></div></Col>
              <Col xs={6} lg={6}><p>{bankListMap(orderDetailsState.modeOfPayment.bank)}</p></Col>
              <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Check Number</label></div></Col>
              <Col xs={6} lg={6}><p>{orderDetailsState.modeOfPayment.checkNumber}</p></Col>
            </> : ''
          }
          { orderDetailsState.modeOfPayment && orderDetailsState.modeOfPayment.option === 'DIRECT_DEBIT'
            ? <>
              <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Bank</label></div></Col>
              <Col xs={6} lg={6}><p>{bankListMap(orderDetailsState.modeOfPayment.bank)}</p></Col>
              <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Account Number</label></div></Col>
              <Col xs={6} lg={6}><p>{orderDetailsState.modeOfPayment.debitAccountNumber}</p></Col>
            </> : ''
          }
          { orderDetailsState.modeOfPayment && orderDetailsState.modeOfPayment.option === 'BANK_BONDS'
            ? <>
              {/* orderDetailsState.contactNumbers && orderDetailsState.contactNumbers.faxNumbers.join(', ') */}
              <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Amount in Figures</label></div></Col>
              <Col xs={6} lg={6}><p>₱{toCurrency(orderDetailsState.modeOfPayment.amountInFigures)}</p></Col>
              {/* {orderDetailsState.modeOfPayment.amountInFigures.map((key, figure) => {
                <Col xs={6} lg={6}><p>{toCurrency(figure)}</p></Col>
                {console.log(toCurrency(figure))}
                {console.log(toCurrency(key))}
              })} */}
              
              
              <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Amount in Words</label></div></Col>
              {/* <Col xs={6} lg={6}><p>{orderDetailsState.modeOfPayment.amountInWords[0]}</p></Col> */}
              <Col xs={6} lg={6}><p>{numToWords()(parseInt(orderDetailsState.modeOfPayment.amountInFigures)).toUpperCase()}</p></Col>
              {/* {orderDetailsState.modeOfPayment.amountInFigures.map((figure) => {
                <Col xs={6} lg={6}><p>{numToWords()(parseInt(figure))}</p></Col>
              })} */}
            </> : ''
          }

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>

          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Mode of Collection of Interest and Principal Payments</label></div></Col>
          <Col xs={6} lg={6}><p>{modeOfCollectionOfInterestMap(orderDetailsState.modeOfCollectionOfInterest)}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Settlement Bank</label></div></Col>
          <Col xs={6} lg={6}><p>{bankListMap(orderDetailsState.settBankCode)}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="id-type">Bank Account Number</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.bankPesoAccountNumber}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">Statement Delivery Mode</label></div></Col>
          <Col xs={6} lg={6}><p>{deliveryModesMap(orderDetailsState.statementDeliveryMode)}</p></Col>

          <Col lg={12}><div className={`${styles['line']} ${styles['order-summary-line']}`}></div></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">Registration of Securities</label></div></Col>
          <Col xs={6} lg={6}><p>{securityRegistrationMap(orderDetailsState.securityRegistration)}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">Name of PDTC Depository Participant</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.pdtcDepositoryParticipantName ? orderDetailsState.pdtcDepositoryParticipantName : 'None'}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">Applicant NoCD/BP ID</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.applicantNoCDBPID ? orderDetailsState.applicantNoCDBPID : 'None'}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">PDTC Depository Participant BP ID</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.pdtcDepositoryParticipantBPID ? orderDetailsState.pdtcDepositoryParticipantBPID : 'None'}</p></Col>
          <Col xs={6} lg={6}><div className={styles['label']}><label data-testid="tax-status">PDTC Depository Participant Omnibus Account No.</label></div></Col>
          <Col xs={6} lg={6}><p>{orderDetailsState.pdtcDepositoryParticipantOmnibusAccNo ? orderDetailsState.pdtcDepositoryParticipantOmnibusAccNo : 'None'}</p></Col>

        </Row>
        {securityState.securityStatus === '0'
          ? (
            <Row className={styles['button-row']}>
              <Col xs={6} lg={6}>
                {order.orderStatus === '0' ? (
                  <div className={styles['accept-button']}>
                    <Button onClick={() => setPage(ACCEPT)}>ACCEPT</Button>
                  </div>
                ) : ''}
              </Col>
              <Col xs={6} lg={6}>
                {order.orderStatus !== '2' ? (
                  <div>
                    <Button onClick={() => setPage(REJECT)} variant="danger">REJECT</Button>
                  </div>
                ) : ''}
              </Col>
            </Row>
          ) : ''
        }
      </div>
  }

  return renderModalScreen()
}

export default OrderSummaryModalContent;
